
export function isPosthogTrackEnabled() {
    if(import.meta.env.VITE_POSTHOG_TRACK === '1') {
        return true;
    }

    return false;
}
